
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32.649","height":"31.28"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.422 0A3.426 3.426 0 000 3.422v16.425a3.426 3.426 0 003.422 3.422h2.834a3.871 3.871 0 01-1.817 4.2.684.684 0 00.352 1.271 8.382 8.382 0 008-5.475h2.393a8.2 8.2 0 01-.123-1.369h-2.742a.682.682 0 00-.642.448 7.126 7.126 0 01-4.86 4.756 6.1 6.1 0 00.7-4.636.685.685 0 00-.674-.561H3.422a2.056 2.056 0 01-2.053-2.053V3.422a2.056 2.056 0 012.053-2.053h24.637a2.056 2.056 0 012.053 2.053v13.941a8.161 8.161 0 011.263 3.287 3.383 3.383 0 00.106-.8V3.422A3.426 3.426 0 0028.059 0zm19.846 15.056A6.844 6.844 0 1027.6 27.194l4.086 4.086.968-.968-4.086-4.086a6.837 6.837 0 00-5.294-11.17zm0 1.369a5.475 5.475 0 11-5.474 5.475 5.465 5.465 0 015.474-5.475z","fill":"#fcffff"}})])
          )
        }
      }
    